import { admin2 } from './instance'

export const GetBranchStore = async ({
  shopId,
  start,
  limit,
  name,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/branch`,
    params: {
      start,
      limit,
      name,
    },
  })
}
export const GetBranchStoreCount = async ({
  shopId,
  name,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/branch/count`,
    params: {
      name,
    },
  })
}
export const FindBranchStore = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/branch/${id}`,
  })
}

export const BatchCreateBranchStore = async ({
  shopId,
  data,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/branch/batchCreate`,
    data: {
      data,
    },
  })
}

export const CreateBranchStore = async ({
  shopId,
  name,
  address,
  phone,
  contact,
  order,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/branch`,
    data: {
      name,
      address,
      phone,
      contact,
      order,
    },
  })
}

export const UpdateBranchStore = async ({
  shopId,
  storeId,
  name,
  address,
  contact,
  phone,
  order,
  custom,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/branch/${storeId}`,
    data: {
      name,
      address,
      contact,
      phone,
      order,
      custom,
    },
  })
}

// admin.branchBusinessTime.findAll
export const GetBranchStoreBusinessTime = async ({
  shopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/branchBusinessTime/all`,
  })
}

// admin.branchBusinessTime.singleFind
export const FindBranchStoreBusinessTime = async ({
  shopId,
  branchId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/branchBusinessTime`,
    params: {
      branchId,
    },
  })
}

// admin.branchBusinessTime.singleUpdate
export const UpdateBranchStoreBusinessTime = async ({
  shopId,
  branchId,
  mode,
  customWeekConfigs,
  excludeTimeRules,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/branchBusinessTime`,
    params: {
      branchId,
    },
    data: {
      mode,
      customWeekConfigs,
      excludeTimeRules,
    },
  })
}
